import React from 'react';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import { langCodeAllowed } from '../../locales';
class AppHelmet extends React.PureComponent {
  constructor(props) {
    super(props);
  }
  render() {
    const {
      pathname,
      yotpoSiteRating,
      yotpoSiteReviewCount,
      section,
      location,
      localeInfo,
      redisCommonData,
    } = this.props;
    const { domain } = localeInfo;
    const keysArray = Object.keys(langCodeAllowed);
    const linkArray = [];
    if (section !== 'cat' && section !== 'prod') {
      const { SEO_ALTERNATE_STATIC_PAGES } = redisCommonData || {};
      const dataSeoAlternateFirebase =
        SEO_ALTERNATE_STATIC_PAGES && JSON.parse(SEO_ALTERNATE_STATIC_PAGES);
      if (
        dataSeoAlternateFirebase &&
        Object.keys(dataSeoAlternateFirebase) &&
        Object.keys(dataSeoAlternateFirebase).includes(pathname)
      ) {
        linkArray.push({
          rel: 'canonical',
          href: dataSeoAlternateFirebase?.[pathname]?.canonical
            ? dataSeoAlternateFirebase?.[pathname]?.canonical
            : `${localeInfo?.domain}${location.pathname}`,
        });
        linkArray.push({
          rel: 'alternate',
          href: (function () {
            if (dataSeoAlternateFirebase?.[pathname]?.alternate?.['en-in'])
              return dataSeoAlternateFirebase?.[pathname]?.alternate?.['en-in'];
            else if (location) {
              return `${localeInfo?.domain}${location.pathname}`;
            }
            return localeInfo?.domain;
          })(),
          hreflang: 'x-default',
        });
        dataSeoAlternateFirebase?.[pathname]?.alternate &&
          Object.keys(dataSeoAlternateFirebase?.[pathname]?.alternate)?.forEach(key => {
            linkArray.push({
              rel: 'alternate',
              hrefLang: key,
              href: dataSeoAlternateFirebase?.[pathname]?.alternate[key],
            });
          });
      } else {
        keysArray.map(keys =>
          linkArray.push({
            rel: 'alternate',
            hrefLang: `${langCodeAllowed[keys]?.hrefLang?.toLowerCase()}`,
            href: location.search
              ? `${langCodeAllowed[keys].domain}${pathname}${location.search}`
              : `${langCodeAllowed[keys].domain}${pathname}`,
          })
        );
      }
    }
    const SCHEMA_APP = redisCommonData?.SCHEMA_APP && JSON.parse(redisCommonData?.SCHEMA_APP);
    return (
      <Helmet
        link={linkArray}
        script={[
          {
            type: 'application/ld+json',
            innerHTML: JSON.stringify({
              ...{
                '@context': 'https://schema.org',
                '@type': 'Organization',
                url: `${domain}`,
                name: SCHEMA_APP?.name || 'Lenskart.com',
                contactPoint: {
                  '@type': 'ContactPoint',
                  telephone: SCHEMA_APP?.contactPoint?.telephone || '+91-99998-99998',
                  contactType: SCHEMA_APP?.contactPoint?.contactType || 'Customer Service',
                },
                sameAs: SCHEMA_APP?.sameAs || [],
                logo:
                  SCHEMA_APP?.logo ||
                  'https://static.lenskart.com/media/mobile/images/lenskart_icon_512X512.png',
              },
              ...(['/', '/reviews'].includes(pathname) && yotpoSiteRating
                ? {
                    aggregateRating: {
                      '@type': 'AggregateRating',
                      ratingValue: yotpoSiteRating,
                      bestRating: 5,
                      reviewCount: yotpoSiteReviewCount,
                    },
                  }
                : {}),
            }),
          },
          {
            type: 'application/ld+json',
            innerHTML: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'WebSite',
              url: `${domain}`,
              potentialAction: {
                '@type': 'SearchAction',
                target: `${domain}/search?q={search_term_string}`,
                'query-input': 'required name=search_term_string',
              },
            }),
          },
        ]}
      ></Helmet>
    );
  }
}

const mapStateToProps = state => ({
  yotpoSiteRating: state.yotpo.yotpoSiteRating,
  yotpoSiteReviewCount: state.yotpo.yotpoSiteReviewCount,
});

export default connect(mapStateToProps)(AppHelmet);
